import { Avatar, Text } from '@gympass/yoga';
import { Exit, Help } from '@gympass/yoga-icons';
import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { MIN_WIDTH_TO_COLLAPSE_MENU } from 'utils/shared/const';

import Divisor from 'components/Divisor';

import { MenuIdProps } from './types';

import * as S from './styles';

const HELP_CENTER_URL =
  'https://wellz.zendesk.com/hc/pt-br/categories/5015273151635';

const MenuId: React.FC<MenuIdProps> = ({ user, avatarUrl, onSignOut }) => {
  const intl = useIntl();

  const menuIsCollapsed = window.innerWidth <= MIN_WIDTH_TO_COLLAPSE_MENU;
  return (
    <S.Wrapper>
      <Tooltip
        title={intl.formatMessage({ id: 'MENU.ID.HELP_CENTER' })}
        placement="right"
        arrow
        disableHoverListener={!menuIsCollapsed}
      >
        <S.HelpCenter
          as="a"
          target="_blank"
          href={HELP_CENTER_URL}
          rel="noopener noreferrer"
        >
          <span>{intl.formatMessage({ id: 'MENU.ID.HELP_CENTER' })}</span>

          <Help />
        </S.HelpCenter>
      </Tooltip>

      <Divisor marginBlock />

      <S.UserWrapper>
        <Avatar.Circle src={avatarUrl} alt="Specialist avatar" />
        <S.UserInfo>
          <Text.Small fontWeight="medium">{user?.fullName}</Text.Small>
          <Text.Tiny as="span" color="deep">
            {user?.occupation}
          </Text.Tiny>
        </S.UserInfo>
        <S.Logout
          aria-label="logout"
          icon={Exit}
          inverted
          onClick={onSignOut}
        />
      </S.UserWrapper>
    </S.Wrapper>
  );
};

export default MenuId;
